import './FeedRefreshNotice.css';

const FeedRefreshNotice = ({ state, updatingLabel, readyLabel = 'Updates available', onShow, onRetry }) => {
    if (state === 'idle' || !state) return null;
    const refreshing = state === 'refreshing';
    const failed = state === 'failed';
    const actionable = state === 'ready' || failed;
    const label = refreshing ? updatingLabel : failed ? 'Couldn’t update.' : readyLabel;
    const action = failed ? 'Retry' : 'Show';
    return (
        <div className='feedRefreshNotice' role='status' aria-live='polite' aria-atomic='true'>
            <div className={`feedRefreshNoticeRow${actionable ? ' hasAction' : ''}`}>
                {actionable && <button className='feedRefreshNoticeButton' type='button'
                    onClick={failed ? onRetry : onShow}>
                    <span className='feedRefreshNoticeAccessibleLabel'>{label.replace(/\.$/, '')}. {action}.</span>
                </button>}
                <span className='feedRefreshNoticeLabel' aria-hidden={actionable}>
                    {[updatingLabel, readyLabel, 'Couldn’t update.'].map(text => (
                        <span className='feedRefreshNoticeLabelSizer' aria-hidden='true' key={text}>{text}</span>
                    ))}
                    <span className='feedRefreshNoticeLabelText' key={label}>{label}</span>
                </span>
                <span className='feedRefreshNoticeAction' aria-hidden='true'>
                    <span className='feedRefreshNoticeActionText' style={{ visibility: actionable ? 'visible' : 'hidden' }}>
                        {action}
                    </span>
                    {refreshing && <span className='feedRefreshNoticeSpinner' />}
                </span>
            </div>
        </div>
    );
};

export default FeedRefreshNotice;
